import { ZERO_UUID } from 'commons/constants/parse.js';
import { BAN_LEVELS } from '@/constants/bans.js';
import { USER_LOAD_STATUSES } from '@/constants/users.js';
import { TWITTER_UUID, INSTAGRAM_UUID } from '@/constants/origin.js';
import twitter from '@/assets/images/twitter.png';
import instagram from '@/assets/images/instagram.png';

export const state = (users) => ({
    current: ZERO_UUID,
    users: {
        [ZERO_UUID]: getDefaultUser(ZERO_UUID),
        [TWITTER_UUID]: formatUser({
            name: 'social.twitter',
            uuid: TWITTER_UUID,
            pic_large: twitter,
            pic_small: twitter,
        }),
        [INSTAGRAM_UUID]: formatUser({
            name: 'social.instagram',
            uuid: INSTAGRAM_UUID,
            pic_large: instagram,
            pic_small: instagram,
        }),
        ...users,
    },
});

export const formatUser = (user = {}) => ({
    uuid: ZERO_UUID,
    comments: [],
    total_comments: 0,
    ban_level: BAN_LEVELS.NONE,
    bans: [],
    bad_comments: 0,
    date_created: new Date(),
    email: '',
    email_pending: '',
    email_verification_status: '',
    name: '',
    username_pending: '',
    username_moderation_status: '',
    avatar_moderation_status: 'none',
    pic_large: '',
    pic_small: '',
    site_uuid: ZERO_UUID,
    disabled_content_ratio: 0,
    tag_agreement_rate: 0,
    total_community_tags: 0,
    total_bans: 0,
    processing_status: '',
    // Present on every record so clobber() can update it — clobber only copies keys the record already has.
    load_status: USER_LOAD_STATUSES.LOADED,
    ...user,
});

export const getDefaultUser = (name, load_status = USER_LOAD_STATUSES.LOADED) => formatUser({
    name,
    load_status,
});
